'use client';

import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { Box, Flex, Modal, Tabs } from '@mantine/core';
import modalStyle from '../Shares/Modal.module.css';
import { Account } from './Account';
import { Overview } from './Overview';
import { ProfileTab } from './ProfileTab';
import classes from './ProfileTab.module.css';
import { Referrals } from './Referrals';
import { Stats } from './Stats';
import { Transaction } from './Transaction';
import { Vip } from './Vip';
export const Profile: React.FC = () => {
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <Modal opened={openModal === MODAL.PROFILE} onClose={() => setOpenModal(null)} closeButtonProps={{
    size: 37,
    bg: 'transparent',
    icon: <Icons className="icon-pr-line-close" fontSize={37} />
  }} overlayProps={{
    bg: 'rgba(23, 26, 30, 0.95)'
  }} size="100%" classNames={modalStyle}>
      <Flex justify="center" w="100%">
        <Flex h="100%" align="center" maw={1320} w={{
        base: '100%',
        sm: 722,
        md: 1320
      }}>
          <Tabs defaultValue="overview" variant="pills" w="100%" classNames={classes} mb={88}>
            <ProfileTab />

            <Box mt={{
            base: 16,
            sm: 20,
            md: 36
          }}>
              <Overview />
              <Vip />
              <Stats />
              <Transaction />
              <Referrals />
              <Account />
            </Box>
          </Tabs>
        </Flex>
      </Flex>
    </Modal>;
};